export enum ToRedirectFromRoute {
  FROM_SIGN_IN = 'FROM_SIGN_IN',
  FROM_SIGN_UP = 'FROM_SIGN_UP',
  FROM_REDIRECT = 'FROM_REDIRECT',
}
